import React from "react";
import Hidden from "@material-ui/core/Hidden";
import Container from "@material-ui/core/Container";

const TopLogo = () => {
  return (
    <Hidden smUp>
      <Container
        style={{
          position: "absolute",
          right: 0,
          bottom: 22,
          zIndex: 999,
          textAlign: "right",
          padding: 16,
        }}
      >
        {window.config && window.config.logo2 && (
          <img alt="Logo 2" src={window.config.logo2} />
        )}
      </Container>
    </Hidden>
  );
};

export default TopLogo;
